<template>
  <div class="container-block" style="margin: 15px 0">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="配方原料">
        <raw-material :rowId="rowId" :factoryId="factoryId"/>
      </a-tab-pane>
      <a-tab-pane key="2" tab="配方营养需要量">
        <nutrition-analysis :rowId="rowId" :factoryId="factoryId"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import RawMaterial from "./RawMaterial";
import NutritionAnalysis from "./NutritionAnalysis";
export default {
  props:{
    rowId:{
      type: String,
      default: ''
    },
    factoryId:{
      type: String,
      default: ''
    }
  },
  components:{
    RawMaterial,
    NutritionAnalysis
  },
  data(){
    return {
      name: 'ddd',
    }
  },
  methods:{
  }
}
</script>